import { StoredFilterRequest, StoredFiltersRequest, StoredFiltersRequestDelete, UpdateStoredFilterRequest } from "../entities/Filter/StoredFiltersRequest";
import { StoredFiltersResponse } from "../entities/Filter/StoredFiltersResponse";
import RequestService from "./RequestService";

class StoredFiltersService {
    public static getList(request: StoredFiltersRequest): Promise<Error | StoredFiltersResponse> {
        return RequestService.post("/storedfilter/list", { ...request });
    }
    public static set(request: StoredFilterRequest): Promise<Error | { "refreshlists": number, "Id": number }> {
        return RequestService.post("/storedfilter/set", { ...request });
    }
    public static delete(request: StoredFiltersRequestDelete): Promise<Error | unknown> {
        return RequestService.post("/storedfilter/delete", { ...request });
    }
    public static update(request: UpdateStoredFilterRequest): Promise<Error | unknown> {
        return RequestService.post("/storedfilter/updatefilter", { ...request });
    }
}

export default StoredFiltersService;